const NAME = "ASSETS_DISCOUNTS_MASSIVE_ENTRY";

export default NAME;
